
export function truncate(string, maxLength) {
    return (string.length > maxLength) ? string.substring(0, maxLength) + '\u2026' : string;
}
